<template>
  <!-- 抽屉，弹出批次管理设备的详情 -->
  <el-drawer
        :befor-close="closeView"
        :append-to-body="true"
        class="drawer"
        size="50%"
        :withHeader="true"
        show-close
          title="批次详情"
          :visible.sync="showDetailView.show"
          :with-header="false">
          <template slot="title">
            <div class="title">批次详情</div>
          </template>
          <div class="detailContent cgray-01">
            <div class="flex1">
              <el-row class="title">
                <el-col>产品名称：<span>{{batchDetail.productName}}</span></el-col>
              </el-row>
              <el-row :span="24" class="cgray-02 fs10">
                <el-col :span="12">添加时间：<span>{{batchDetail.createTime}}</span></el-col>
                <el-col :span="12">添加数量：<span>{{batchDetail.batchNum}}</span></el-col>
              </el-row>
            </div>
            <!-- <div>
              <el-button>下载CSV</el-button>
            </div> -->
          </div>
          <div class="donwloadBtn">
              <el-button @click="download(batchDetail.batchSecretAddress)">下载CSV</el-button>
          </div>
          <div class="flex1">

            <div class="showDataView2">
              <el-table
                border
                height="100%"
                :data="batchDeviceList"
                tooltip-effect="dark"
                style="width: 100%">
                <template slot="empty">
                  <emptyView></emptyView>
                </template>
                <el-table-column
                  prop="productName"
                  label="productName">
                </el-table-column>
                <el-table-column
                  label="deviceName">
                  <template slot-scope="scope">
                     <el-tooltip :content="scope.row.deviceName" placement="top" effect="light">
                      <div class="ellipsis">{{scope.row.deviceName}}</div>
                     </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                  label="deviceSecret">
                   <template slot-scope="scope">
                     <el-tooltip :content="scope.row.deviceSecret" placement="top" effect="light">
                      <div class="ellipsis">{{scope.row.deviceSecret}}</div>
                     </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                  label="激活状态">
                  <template slot-scope="scope">
                  {{ getStatus(scope.row.deviceStatus)}}
                  </template>
                </el-table-column>
                <el-table-column
                 prop="activationTime"
                  label="激活时间">
                </el-table-column>
              </el-table>
            </div>

          </div>
         <el-row class="footer" :span="24">
           <el-col :span="8">
              <el-button @click="closeView" type="primary" size="small">确 定</el-button>
              <el-button @click="closeView" size="small">关 闭</el-button>
           </el-col>
           <el-col :span="16">
 <!-- v-if是为了保证每次打开抽屉，分页都能重新置为1 -->
              <Paging
              v-if="showDetailView.show"
              :total="batchPageParams.total"
              pagingStatus="short"
              @changePage="currentPageChange"/>
           </el-col>
          </el-row>
        </el-drawer>
</template>
<script>
import emptyView from '@/components/empty_view/empty'
import Paging from '@/components/paging'
import { loadFileByUrl } from '@/utils'
export default {
  components: {
    emptyView,
    Paging
  },
  props: {
    showDetailView: {
      type: Object
    },
    batchDetail: {
      type: Object
    },
    batchDeviceList: {
      type: Array
    },
    batchPageParams: {
      type: Object
    }
  },
  data () {
    return {
      pageParams: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    closeView () {
      this.$emit('close-view')
    },
    currentPageChange (listQuery) {
      this.$emit('current-page-change', listQuery)
    },
    download (path) {
      if (path) {
        loadFileByUrl(path)
      } else {
        this.$message.error('暂无文件！')
      }
    },
    getStatus (deviceStatus) {
      const stateParams = {
        0: 'ONLINE',
        1: 'OFFLINE',
        2: 'UNACTIVE',
        3: 'DISABLE'
      }
      return stateParams[deviceStatus]
    }
  },
  watch: {

  }
}
</script>
<style lang="less" scope>
.drawer{
    overflow-y: auto;
    .title{
      font-size: 20px;
    }
    .detailContent{
      display: flex;
      background-color: #fbfbfc;
      border: 1px solid #ecedee;
      padding: 20px;
      .flex1{
        flex:auto;

      }
    }
    .flex1{
      flex:auto;
      position: relative;
      margin-top: 20px;
      .el-row{
        margin-top: 10px;
      }
      .title{
        font-size: 18px;
      }
    }
    .cgray-01{
      color: rgb(51, 51, 51)
    }
    .cgray-02{
      color: rgb(85, 85, 85)
    }
    .fs10{
      font-size: 10px;
    }
    .footer{
      padding: 20px 10px ;
    }
    .el-drawer__body{
      margin: 10px 20px;
      display: flex;
      flex-direction: column;
    }
    .donwloadBtn{
      margin-top: 20px;
    }
  }
</style>
